import { Asset } from "./Asset";
import { Engine } from "@spi/Engine/Engine";
import { HttpBinaryAsset } from "./HttpBinaryAsset";
import { Loader } from "@spi/Common/Collada";
import { ColladaTexture } from "../Texture";
import { ColladaMesh } from "../Mesh";
import { Scene } from "../Scene";

export class ColladaAsset extends Asset {

    private httpAsset: HttpBinaryAsset;

    constructor(public scene: Scene, uri: string) {
        super();
        this.httpAsset = new HttpBinaryAsset(uri, (engine, buffer) => this.loadColladaFile(engine, buffer));
    }

    resolveAsset(engine: Engine): Promise<void> {
        return this.httpAsset.resolveAsset(engine);
    }

    private loadColladaFile(engine: Engine, rawData: ArrayBuffer) {
        let loader = new Loader();
        let colladaObjects = loader.processData(rawData);

        for (let o in colladaObjects) {

            let colladaObj = colladaObjects[o];

            // Load textures
            for (let img of colladaObj.imageLibrary) {
                if (img.validImage) {
                    let texture = new ColladaTexture();
                    texture.loadColladaTexture(engine.ctx, img);
                    texture.translucent = img.translucent;
                    this.scene.materialManager.addTexture(img.reference, texture);
                }
            }
            
            // TODO: load all meshes
            let mesh = new ColladaMesh(o, engine.ctx, this.scene, colladaObj);
            mesh.bufferColladaMesh(colladaObj.geometryLibrary[0].mesh);
            this.scene.meshManager.addMesh(o, mesh);
            // console.log(`Collada '${o}' mesh count = ${colladaObj.geometryLibrary.length}`);

            let count = 0;
            for (let geo of colladaObj.geometryLibrary) {
                let m = new ColladaMesh(`${o}/${count}`, engine.ctx, this.scene, colladaObj);
                m.bufferColladaMesh(geo.mesh);
                this.scene.meshManager.addMesh(`${o}/${count}`, m);

                count++;
            }


        }
    }
}
